import { Col, Form, theme } from 'antd';

const SHADOW_OFFSET = 1 // px

export const FilterField = ({
  name,
  col = { span: 24 }, // Si se pasa false o null no se aplica <Col>
  modifiedFilters, // Set con los nombres de filtros que han sido modificados
  children,
  ...formItemProps
}) => {
  const { token: themeToken } = theme.useToken();

  const isModified = modifiedFilters
    ? Array.isArray(name)
      ? name.some((field) => modifiedFilters.has(field)) // Si 'name' es un array, comprueba si al menos un elemento de 'name' está en 'modifiedFilters'
      : modifiedFilters.has(name)
    : false;

  // Se aplica sombra solo a los filtros modificados
  const shadow = `drop-shadow(0px 0px ${SHADOW_OFFSET}px ${themeToken.colorPrimary}) `;
  const wrapperColStyle = {
    filter: isModified ? shadow.repeat(2).trim() : 'none',
    transition: 'filter 0.5s ease',
    minHeight: 'min-content', // Garantiza que el contenedor tenga al menos la altura de su contenido, evitando colapsos incluso si el layout del Form.Item es 'horizontal'
  };

  const formItem = (
    <Form.Item
      name={name}
      {...formItemProps}
      style={{
        marginBottom: 0, // Elimina el margen inferior por defecto de Form.Item
        ...formItemProps.style,
      }}
      wrapperCol={{
        ...formItemProps.wrapperCol,
        style: {
          ...formItemProps.wrapperCol?.style,
          ...wrapperColStyle, // Estos estilos prevalecen sobre los estilos proporcionados para asegurar el efecto de sombra
        },
      }}
    >
      {children}
    </Form.Item>
  )

  return col ? <Col {...col}>{formItem}</Col> : formItem
};